import {CssValue} from '@sail/engine/deprecated';
import {IconAsset} from '@sail/icons/types';
import {stripe} from '@sail/icons/react/BrandIcon';

export interface Theme {
  brandColor: string;
  onBrandTextColor: string;
  ctaColor: string;
  ctaHoverColor: string;
  onCtaTextColor: string;
  textColor: string;
  linkColor: string;
  avatarGradientStart?: string;
  avatarGradientEnd?: string;
  headerBarGradient?: string;
  focusVisibleOutline?: CssValue<string>;
  icon: IconAsset;
  messageKey?: string;
  assistantIconColor0?: string;
  assistantIconColor1?: string;
  assistantHeaderTitle?: string;
  audience?: string;
}

export const DefaultTheme: Theme = {
  brandColor: '$color.brand500',
  onBrandTextColor: '$color.neutral100',
  ctaColor: '$color.brand500',
  ctaHoverColor: '$hue.purple600',
  onCtaTextColor: '$color.neutral100',
  textColor: '$color.text',
  linkColor: '$color.brand500',
  avatarGradientStart: '$color.brand400',
  avatarGradientEnd: '$color.brand600',
  icon: stripe,
  assistantIconColor0: 'url(#paint0_linear_757_90506)',
  assistantIconColor1: 'url(#paint1_linear_757_90506)',
  assistantHeaderTitle: 'Assistant',
  audience: 'stripe',
};
